document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('intro-overlay');
  const video = document.getElementById('intro-video');
  const body = document.body;

  // Wenn kein Intro vorhanden ist (nicht Startseite), nichts tun
  if (!overlay || !video) return;

  const INTRO_KEY = 'intro_shown_session_v1';

  // Falls das Intro in dieser Session schon gezeigt wurde -> gar nicht erst aktivieren
  if (sessionStorage.getItem(INTRO_KEY) === '1') {
    overlay.classList.remove('intro-overlay--active');
    overlay.classList.add('intro-overlay--hidden');
    body.classList.remove('intro-lock');
    return;
  }

  // Merken: Intro wurde in dieser Session gestartet
  sessionStorage.setItem(INTRO_KEY, '1');

  // Intro aktivieren
  overlay.classList.add('intro-overlay--active');
  body.classList.add('intro-lock');

  let hasFaded = false;

  const startFade = () => {
    if (hasFaded) return;
    hasFaded = true;
    overlay.classList.remove('intro-overlay--active');
    overlay.classList.add('intro-overlay--hidden');
    body.classList.remove('intro-lock');
  };

  // Wir starten das Fade-Out kurz vor Ende des Videos (z.B. letzte 0,8s)
  video.addEventListener('timeupdate', () => {
    if (!video.duration || hasFaded) return;

    const remaining = video.duration - video.currentTime;

    if (remaining < 0.8) {
      startFade();
    }
  });

  // Falls der "ended"-Event kommt und wir noch nicht gefadet haben -> sicherheitshalber
  video.addEventListener('ended', startFade);

  // Versuche, das Video mit Sound zu spielen (Browser entscheidet)
  const tryPlayWithSound = () => {
    video.muted = false; // Sound AN
    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Autoplay mit Sound wurde blockiert -> ohne Sound abspielen
        video.muted = true;
        video.play().catch(() => {
          // Wenn selbst das nicht klappt -> Intro beenden
          startFade();
        });
      });
    }
  };

  if (video.readyState >= 2) {
    // Video hat genug Daten
    tryPlayWithSound();
  } else {
    video.addEventListener(
      'loadeddata',
      () => tryPlayWithSound(),
      { once: true }
    );
  }

  // Fallback: Egal was passiert -> nach 60 Sekunden Intro sicher entfernen
  setTimeout(() => {
    if (!hasFaded) startFade();
  }, 60000);
});
